import { useDispatch, useSelector } from 'react-redux';
import FJImageToImageRight from './FJImageToImageRight';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJActionImageToImage from '../../../redux/action/FJActionImageToImage';
import useLocalStore from '../../../hooks/useLocalStore';
import { useState } from 'react';

const FJImageToImageRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isCanDownload = useSelector(state => state.common.isDone);

    const [downloadEditImageLoading, setDownloadEditImageLoading] = useState(false);

    const uploadImg = file => {
        dispatch(FJActionImageToImage.uploadImageAction(file));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };

    const download = () => {
        setDownloadEditImageLoading(true);
        dispatch(FJActionImageToImage.downloadAllCreationAction(() => setDownloadEditImageLoading(false)));
    };

    const imageToVideo = () => {
        dispatch(FJActionImageToImage.animateImageAction());
    };

    return (
        <FJImageToImageRight
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            taskStatus={taskStatus}
            headerTabIndex={headerTabIndex}
            isCanDownload={isCanDownload}
            download={download}
            imageToVideo={imageToVideo}
            downloadEditImageLoading={downloadEditImageLoading}
        />
    );
};
export default FJImageToImageRightContainer;
